import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import almacenService from "../services/almacenService";
import { message } from "utils/Funciones";

const initialState = {
    responseSuccessCreate: null,
    responseSuccessGet: null,
    responseSuccessUpdate: null,
    responseSuccessDelete: null,
    data: [],
    almacenesByPage: [],
    totalRow: 0,
    totalPage: 0,
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: "",
    totalStoreValue: 0
};

export const createAlmacen = createAsyncThunk(
    "almacen/createAlmacen",
    async (data, thunkAPI) => {
        try {
            return await almacenService.createAlmacen(data.formData, data.token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const getAlmacenes = createAsyncThunk(
    "almacen/getAlmacenes",
    async (token, thunkAPI) => {
        try {
            return await almacenService.getAlmacenes(token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);


export const getAlmacenesByPage = createAsyncThunk(
    "almacen/getAlmacenesByPage/almacenesbypage",
    async (data, thunkAPI) => {
        try {
            return await almacenService.getAlmacenesByPage(data.query, data.token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const updateAlmacen = createAsyncThunk(
    "almacen/updateAlmacen/almacen",
    async (data, thunkAPI) => {
        try {
            return await almacenService.updateAlmacen(data.formData, data.token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

export const deleteAlmacen = createAsyncThunk(
    "almacen/deleteAlmacen",
    async (data, thunkAPI) => {
        try {
            return await almacenService.deleteAlmacen(data._id, data.token);
        } catch (error) {
            error.response.data.errors.map(err => {
                message(err.message, 'error', 4)
            })
            const msg =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(msg);
        }
    }
);

const almacenSlice = createSlice({
    name: "almacen",
    initialState,
    reducers: {
        SET_TO_DEFAULT_RESPONSE(state, action) {
            state.responseSuccessCreate = null
            state.responseSuccessGet = null
            state.responseSuccessUpdate = null
            state.responseSuccessDelete = null
        },

        CALC_STORE_CATEGORY_VALUE(state, action) {
            const almacenes = action.payload;
            const array = [];
            almacenes.map((item) => {
                const { price, quantity } = item;
                const almacenValue = price * quantity;
                return array.push(almacenValue);
            });
            const totalValue = array.reduce((a, b) => {
                return a + b;
            }, 0);
            state.totalStoreValue = totalValue;
        },

        UPDATE_CATEGORY_FROM_SOCKET(state, action) {


        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(createAlmacen.pending, (state) => {
                //state.isLoading = true;
            })
            .addCase(createAlmacen.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.isError = false;
                state.responseSuccessCreate = action.payload;
                /*if (action.payload.type === 'Streaming' || action.payload.type === 'GiftCard') {
                    //const Arraysubalmacen = state.almacenes.filter(fil => action.payload.newStateData.almacenId === fil._id)
                    //Arraysubalmacen.push(action.payload.newStateData.Objsubalmacen)
                    console.log(action.payload.newStateData.newData)
                    const newStateAlmacen = state.almacenes.map((cat) => {
                        if (cat._id === action.payload.newStateData.almacenId) {
                            cat.subalmacen.push(action.payload.newStateData.newData)
                        }
                        return cat
                    })
                    state.almacenes = newStateAlmacen
                } else {
                    state.almacenes.push(action.payload.newalmacen);
                }*/
            })
            .addCase(createAlmacen.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(getAlmacenes.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAlmacenes.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.isError = false;
                state.data = action.payload.data;
            })
            .addCase(getAlmacenes.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(getAlmacenesByPage.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAlmacenesByPage.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.isError = false;
                state.almacenesByPage = action.payload.data;
                state.totalPage = action.payload.totalPage;
                state.totalRow = action.payload.totalRow;
            })
            .addCase(getAlmacenesByPage.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })


            .addCase(updateAlmacen.pending, (state) => {
                //state.isLoading = true;
            })
            .addCase(updateAlmacen.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.isError = false;
                state.responseSuccessUpdate = action.payload;
                const newStateAlmacenes = state.almacenesByPage.map((item) => {
                    if (item._id === action.payload.newStateData.newData._id) {
                        return {
                            ...item,
                            name: action.payload.newStateData.newData.name,
                            direccion: action.payload.newStateData.newData.direccion,
                            disabled: action.payload.newStateData.newData.disabled,
                            last_update: action.payload.newStateData.newData.last_update
                        }
                    }
                    return item
                })
                state.almacenesByPage = newStateAlmacenes
            })
            .addCase(updateAlmacen.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
            })

            .addCase(deleteAlmacen.pending, (state) => {
                //state.isLoading = true;
            })
            .addCase(deleteAlmacen.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.isError = false;
                state.responseSuccessDelete = action.payload;
            })
            .addCase(deleteAlmacen.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
            })
    },
});

export const { CALC_STORE_CATEGORY_VALUE, UPDATE_CATEGORY_FROM_SOCKET, SET_TO_DEFAULT_RESPONSE } = almacenSlice.actions;

export default almacenSlice.reducer;

